import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const DepositWithdrawTabs = ({ className = "" }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const isDeposit =
    location.pathname === "/deposit" ||
    location.pathname.startsWith("/deposit/");
  const isWithdraw =
    location.pathname === "/withdraw" ||
    location.pathname.startsWith("/withdraw/");

  return (
    <div className={`p-title title-box deposit-tab ${className}`.trim()}>
      <div className="deposit-switch" role="tablist" aria-label="Wallet">
        <button
          type="button"
          role="tab"
          aria-selected={isDeposit}
          className={`deposit-switch-item${isDeposit ? " selected" : ""}`}
          onClick={() => {
            if (!isDeposit) navigate("/deposit");
          }}
        >
          Deposit
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={isWithdraw}
          className={`deposit-switch-item${isWithdraw ? " selected" : ""}`}
          onClick={() => {
            if (!isWithdraw) navigate("/withdraw");
          }}
        >
          Withdrawal
        </button>
      </div>
    </div>
  );
};

export default DepositWithdrawTabs;
